import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Renders assistant/bot markdown safely. react-markdown escapes raw HTML by
// default (no dangerouslySetInnerHTML), remark-gfm adds lists/tables/strikethrough,
// and we clamp link URLs to safe schemes. Styling lives in CSS (.chat-md).

const SAFE_SCHEME = /^(https?:|mailto:)/i;

function safeUrl(url) {
  if (!url) return '';
  if (url.startsWith('#') || url.startsWith('/')) return url; // in-page / relative
  return SAFE_SCHEME.test(url) ? url : '';
}

const components = {
  // Open external links in a new tab; drop links with unsafe schemes.
  a({ href, children, node, ...props }) {
    const safe = safeUrl(href);
    if (!safe) return <>{children}</>;
    return (
      <a href={safe} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  },
};

export default function MarkdownRenderer({ content }) {
  if (!content) return null;
  return (
    <div className="chat-md">
      <Markdown remarkPlugins={[remarkGfm]} urlTransform={safeUrl} components={components}>
        {content}
      </Markdown>
    </div>
  );
}
